import React from 'react';
import css from './ReplacementProtocolPolicyModal.module.css';
import Modal from '../Modal/Modal';
import SignatureCanvas from "react-signature-canvas";
//import SignupForm from '../../containers/AuthenticationPage/SignupForm/SignupForm';
import { requiredFieldArrayCheckbox } from '../../util/validators';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import arrayMutators from 'final-form-arrays';
//import { authenticationInProgress, login, signup, signupWithIdp } from '../../ducks/auth.duck';
//import { sendVerificationEmail } from '../../ducks/user.duck';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import { useState, useEffect } from 'react';
import { Form } from 'react-final-form';
import { FieldCheckboxGroup } from '../../components';
import { useRef } from 'react'

import { PrimaryButton, SecondaryButton, FieldTextInput } from '../../components';
//import LoginForm from '../../containers/AuthenticationPage/LoginForm/LoginForm';

const ReplacementProtocolPolicyModalComponent = props => {
  const {
    isOpen,
    setOpen,
    onModalFormSubmit,
    parentFormValues,
    onManageDisableScrolling,
  } = props;

  const handleSubmit = async values => {
    console.log("handleSubmit");
    await onModalFormSubmit({ ...parentFormValues, ...values });
    setOpen(false);
  };

  // TODO validate signature
  const validate = values => {
    const errors = {};
    if (!values.accept) {
      errors.accept = 'Required';
    }
    if (!values.signature) {
      errors.signature = 'Required';
    }
    return errors;
  }

  const [canvasKey, setCanvasKey] = useState(0);
  const [openModel, setOpenModal] = useState(false)
  const sigCanvas = useRef(null)
  const [imageURL, setImageURL] = useState(null)

  /*
  useEffect(() => {
    if (sigCanvas && sigCanvas.current) {
        // Here you can add any initialization logic you might need
        // For example, clearing the canvas
        sigCanvas.current.clear();
    }
  }, []); // The empty dependency array ensures this runs only on mount
  */

  useEffect(() => {
    setCanvasKey(prevKey => prevKey + 1); // Change key to force re-render
  }, [props.isOpen]); // Run this effect when the popup open state changes

  useEffect(() => {
    console.log("canvasKey: " + canvasKey);
  }, [canvasKey]); // Run this effect when the key changes
  /*
  // first option works, no need for that, but good to know
  useEffect(() => {
    const timer = setTimeout(() => {
        setCanvasKey(prevKey => prevKey + 1);
    }, 500); // Adjust delay as needed

    return () => clearTimeout(timer);
  }, [props.isOpen]);
  */



  const create = () => {
    const URL = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png')
    setImageURL(URL)
    setOpenModal(false)
  }

  const download = () => {
    const dlink = document.createElement("a")
    dlink.setAttribute("href", imageURL)
    dlink.setAttribute("download", "signature.png")
    dlink.click()
  }

  return (
    <Modal
      id="ReplacementProtocolPolicyModal"
      isOpen={isOpen}
      contentClassName={css.modalContent}
      onClose={() => {
        setOpen(false);
      }}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <div className={css.wrapper}>
        <h4>Please verify your understanding of our replacement policy.</h4>

        <div className={css.formsWrapper}>

          <div className={css.form}>
            <Form
              className={css.signupForm}
              mutators={{ ...arrayMutators }}
              onSubmit={handleSubmit}
            >
              {/* >//validate={validate} */}
              {({ handleSubmit, submitting, values }) => (
                <form onSubmit={handleSubmit}>
                  <div className={css.formContent}>
                    <div className={css.formRow}>
                      Renters are responsible for lost items or damage beyond normal wear and tear,
                      up to the item’s listed replacement value. Owners may report damage and provide
                      photos after an item is returned. Setcircle will review each claim before
                      determining any applicable charges.
                      <br />
                      <br />
                      <a
                        href="https://www.setcirclehelp.com/en/articles/10504835-rental-insurance-damages-guide"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <strong>View the full Replacement Policy</strong>
                      </a>
                      <br />
                      <br />

                    </div>

                    <div className={css.formRow}>

                      <FieldCheckboxGroup
                        name="replacementProtocolPolicy"
                        id="replacementProtocolPolicy"
                        optionLabelClassName={css.finePrint}
                        options={[
                          {
                            key: 'replacementProtocolPolicy',
                            label: 'I understand and agree to Setcircle’s Replacement Policy.',
                          },
                        ]}
                        validate={requiredFieldArrayCheckbox(
                          "You need to accept the Replacement Policy to continue."
                        )}
                      />
                    </div>

                    <div className={css.formRow1}>
                      <div className={css.signatureWrapper}>
                        <SignatureCanvas
                          penColor="black"
                          key={canvasKey} // Use dynamic key to force re-render
                          canvasProps={{ className: css.sigCanvas }}
                          ref={sigCanvas}
                        />

                      </div>

                      <SecondaryButton
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          //create(); //TODO for test

                          //const test = sigCanvas.current.toData();
                          sigCanvas.current.clear();
                        }
                        }>Clear</SecondaryButton>
                      <br />

                    </div>
                  </div>
                  <div className={css.submitButtonWrapper}>
                    <PrimaryButton
                      type="submit"
                      inProgress={submitting}
                      disabled={!values.replacementProtocolPolicy} // || sigCanvas.current.toData().length == 0} // TODO check we have signature
                    //https://chat.openai.com/c/0a8a0b01-5a31-4ce6-839e-e4c4d333921f
                    // check if signature is empty check this
                    // then where to save it? we'll see

                    >
                      Submit
                    </PrimaryButton>
                  </div>
                  <div>
                    {
                      imageURL && (
                        <>
                          <img src={imageURL} alt="signature" className="signature" />
                        </>
                      )
                    }
                  </div>
                </form>
              )}
            </Form>
          </div>

        </div>
      </div>

    </Modal>
  );
};

const mapStateToProps = state => {
  //const { isAuthenticated, loginError, signupError, confirmError } = state.auth;
  //const { currentUser, sendVerificationEmailInProgress, sendVerificationEmailError } = state.user;
  //const {
  //  pageAssetsData: privacyAssetsData,
  //  inProgress: privacyFetchInProgress,
  //  error: privacyFetchError,
  //} = state.hostedAssets || {};
  //const { pageAssetsData: tosAssetsData, inProgress: tosFetchInProgress, error: tosFetchError } =
  //  state.hostedAssets || {};

  return {
    //authInProgress: authenticationInProgress(state),
    //currentUser,
    //isAuthenticated,
    //loginError,
    scrollingDisabled: isScrollingDisabled(state),
    //signupError,
    //confirmError,
    //sendVerificationEmailInProgress,
    //sendVerificationEmailError,
    //privacyAssetsData,
    //privacyFetchInProgress,
    //privacyFetchError,
    //tosAssetsData,
    //tosFetchInProgress,
    //tosFetchError,
  };
};

const mapDispatchToProps = dispatch => ({
  //submitLogin: ({ email, password }) => dispatch(login(email, password)),
  //savePolicyProtocol: ({ signature }) => dispatch(savePolicyProtocol(signature)),
  //submitSignup: params => dispatch(signup(params)),
  //submitSingupWithIdp: params => dispatch(signupWithIdp(params)),
  //onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const ReplacementProtocolPolicyModal = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(ReplacementProtocolPolicyModalComponent);

export default ReplacementProtocolPolicyModal;
